import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

const styles = makeStyles(({ spacing }) => ({
  sendAgainWrapper: {
    padding: spacing(3),
    borderRadius: 8,
    backgroundColor: grey["50"],
    border: `1px solid ${grey["100"]}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  sendAgainSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  sendAgainText: {
    fontSize: "16px !important",
    fontWeight: 400,
    lineHeight: 1.5,
    gap: spacing(0.5),
  },
  buttonText: {
    fontSize: "16px !important",
    fontWeight: 500,
    lineHeight: 1.5,
    textDecoration: "underline",
    textTransform: "none",
  },
}));
export default styles;
